<div class="main-screen-container">
    <div class="top-row">

        <button mat-flat-button class="btn-action btn-with-icon" color="accent"
            (click)="router.navigate(['integrations'])"><img style="width:25px;" src="/assets/img/back.png"
                alt="">Powrót</button>

    </div>
    <mat-card class="list-container">
        <mat-card-content>
            <div class="row">
                <div class="col">
                    <div class="add-form">
                        <h3>{{ getTitle() }} integrację</h3>
                        <form [formGroup]="editForm" (ngSubmit)="onSubmit()" class="form-layout">
                            <input type="hidden" formControlName="id">
                            <mat-form-field appearance="outline" style="width:100%;">
                                <mat-label>Nazwa</mat-label>
                                <input matInput type="text" placeholder="Nazwa" required formControlName="name">
                            </mat-form-field>
                            <mat-form-field appearance="outline" style="width:100%;">
                                <mat-label>Karta integracyjna</mat-label>
                                <mat-select formControlName="cardUuid">
                                    @for (item of integrationsService.integrationCards; track item.id) {
                                    <mat-option [value]="item.uuid">{{item.description}}</mat-option>
                                    }
                                </mat-select>
                            </mat-form-field>
                            <div>Aktualne UUID: <br />{{ editForm.get('cardUuid')?.value }}</div>
                            <mat-slide-toggle class="example-margin" [checked]="currentIntegration.active"
                                formControlName="active">
                                Aktywna
                            </mat-slide-toggle>
                            <button mat-flat-button class="btn-action btn-large" color="accent">Zapisz</button>
                        </form>
                    </div>
                </div>
                <div class="col-9 d-flex flex-column" style="gap:20px;">
                    <app-params-list *ngIf="integrationId > 0" [params]="currentIntegration.params"></app-params-list>
                    <app-images-list *ngIf="integrationId > 0" [images]="currentIntegration.images"></app-images-list>

                </div>
            </div>
        </mat-card-content>
    </mat-card>
    <div style="height:50px">

    </div>
</div>